<app-collapsible-container [id]="'educationLevel'"
                           [title]="'REPERTOIRE.FORMS.EDUCATION-LEVEL.TITLE'"
                           [icon]="'i-graduation-cap'"
                           [maxSelection]="(educationLevels$ | async).length"
                           [currentSelected]="control.value.length"
                           (elementSizeModification)="elementSizeModification.emit()"
>
    <app-generic-radio-checkbox [config]="{
                                            formGroupName: 'educationLevel',
                                            inputType: 'checkbox',
                                            questionChoices: educationLevels$ | async
                                        }" [formControl]="control" [readOnly]="readonly">
    </app-generic-radio-checkbox>
    <app-form-errors
        *ngIf="control.touched"
        [errors]="control.errors"
        (errorDisplay)="elementSizeModification.emit()"
    ></app-form-errors>
</app-collapsible-container>

